import React, { useContext, useState, useEffect } from "react";

import styles from "./style.module.scss";

// import fire1 from "../../assets/image/green.png";
// import fire2 from "../../assets/image/yellow.png";
// import fire3 from "../../assets/image/red.png";
// import fire4 from "../../assets/image/danger.png";

import { MainContext } from "../../context/MainContext";

import { Flame, EyeOffIcon, EyeIcon, EyeClosedIcon } from "lucide-react";

function SelectedIcons() {
  const { buttons, setButtons, isStatusActiveIcon, setIsStatusActiveIcon, user } =
    useContext(MainContext);

  const handleButtonClick = (button) => {
    setButtons((prev) => {
      if (prev.includes(button)) {
        return prev.filter((b) => b !== button); // Снимаем выбор
      } else {
        return [...prev, button]; // Добавляем выбор
      }
    });
  };

  return (
    <div>
      <div className={styles.container}>
        <button
          className={buttons.includes("button1") ? styles.button : styles.buttonBlur}
          onClick={() => handleButtonClick("button1")}
        >
          <Flame color="#41f500" />
        </button>
        <button
          className={buttons.includes("button2") ? styles.button : styles.buttonBlur}
          onClick={() => handleButtonClick("button2")}
        >
          <Flame color="#f5c000" />
        </button>
        <button
          className={buttons.includes("button3") ? styles.button : styles.buttonBlur}
          onClick={() => handleButtonClick("button3")}
        >
          <Flame color="#f50000" />
        </button>
      </div>
      <div className={styles.container__eye}>
        {user.data.main_id.length > 0 ? (
          <button
            className={buttons.includes("button3") ? styles.button : styles.buttonBlur}
            onClick={() => setIsStatusActiveIcon(!isStatusActiveIcon)}
          >
            {isStatusActiveIcon ? <EyeIcon color="#41f500" /> : <EyeOffIcon color="#ff0e00" />}
          </button>
        ) : (
          <button className={buttons.includes("button3") ? styles.button : styles.buttonBlur}>
            <EyeClosedIcon />
          </button>
        )}
      </div>
    </div>
  );
}

export default SelectedIcons;
